<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!-- <h4 class="FullWidth" style="text-align: center;">History</h4> -->

	<!--Buttons-->
	<div class="button-body flex">
		<button class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">Refresh</button>

		<!--INSERT CUSTOM BUTTONS HERE-->
		<button class="btn btn-primary" style="margin-left: 5px" (click)="onViewSubHistory()">View Details</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstSubstitution"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedSubstitution"
		dataKey="SubstitutionID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--StartDate-->
				<th>
					<!-- <p-columnFilter type="text" field="StartDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--EndDate-->
				<th>
					<!-- <p-columnFilter type="text" field="EndDate" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ClassAttendanceRecordCount-->
				<th>
					<!-- <p-columnFilter type="text" field="ClassAttendanceRecordCount" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--ClassAttendanceClasses-->
				<th>
					<p-columnFilter type="text" field="ClassAttendanceClasses" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PersonName">Subbing For<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th pSortableColumn="StartDate">Start Date<p-sortIcon field="StartDate"></p-sortIcon></th>
				<th pSortableColumn="EndDate">End Date<p-sortIcon field="EndDate"></p-sortIcon></th>
				<th pSortableColumn="ClassAttendanceRecordCount">Class Attendance Records<p-sortIcon field="ClassAttendanceRecordCount"></p-sortIcon></th>
				<th pSortableColumn="ClassAttendanceClasses">Classes<p-sortIcon field="ClassAttendanceClasses"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Substitution>
			<tr [pSelectableRow]="Substitution" (dblclick)="onRowDblClick(Substitution)">
				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Substitution[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
